<template>
    <div>
        <div id="reset-password" class="wrapper m0-50 critical">
            <div class="section">
                <div class="div-block-15">
                    <div class="form-container" v-if="!this.tokenError">
                        <div class="form-block w-form">
                            <div id="email-form" class="form-wrapper">
                                <div class="form-title-container">
                                    <div class="form-title">Reset Password</div>
                                    <p>Please enter a new password below.</p>
                                </div>
                                <form @submit.prevent="submit">
                                    <div class="input-container" :class="{ 'hasError': $v.form.password.$error }">
                                        <label for="password" class="input-label">Password</label>
                                        <input type="password"
                                               class="text-input w-input"
                                               maxlength="256"
                                               name="password"
                                               data-name="password"
                                               v-model="form.password"
                                               @blur="$v.form.password.$touch()"
                                               placeholder="Enter your password..."
                                               id="password" >
                                        <div class="text-red" v-if="$v.form.password.$error">
                                            <div v-if="!$v.form.password.required">Password is required</div>
                                            <div v-if="!$v.form.password.minLength">Password should be at-least 8 character</div>
                                            <div v-if="!$v.form.password.strongPassword">Password should have 1 special character, 1 lowercase, 1 uppercase, and  1 number</div>
                                        </div>
                                    </div>
                                <button type="submit" data-wait="Please wait..." class="submit-button w-button float-right">Reset Password</button>
                                </form>
                            </div>
                            <div class="input-container form-success" v-if="success">
                                <div>Thank you! Please <router-link class="link-blue" v-bind:to="'/login'">login</router-link>.</div>
                            </div>
                            <div class="input-container form-fail" v-if="fail">
                                <div>Oops! Something went wrong. Please check your email for password reset link or request link <router-link class="link-blue" v-bind:to="'/forget-password'">again</router-link>.</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-container" v-if="this.tokenError">
                        <div class="form-fail">
                            <div>Oops! Something went wrong. Please check your email for password reset link or request link <router-link class="link-blue" v-bind:to="'/forget-password'">again</router-link>.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { userService } from '../assets/js/services/userService';
import {required, minLength} from "vuelidate/lib/validators";

    export default {
        name: "ResetPassword",
        data() {
            return {
                form: {
                    password: "",
                },
                token: "",
                success: false,
                fail: false,
                tokenError:false,
            }
        },

        validations: {
            form: {
                password: { required,  minLength: minLength(8),
                    strongPassword(password) {
                        const passwordRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
                        return passwordRegex.test(password);
                    }}
            }
        },

        components: {
        },
        created () {
            document.title = "Reset Password";//Set the document title
            const token = this.$route.query.token;
            if (!token){
                this.tokenError = true;
            }else {
                this.token = token;
            }
        },
        methods: {
            submit () {
                this.success = false;
                this.fail = false;
                this.tokenError = false;

                this.$v.form.$touch();
                if(this.$v.form.$error) return;
                // to form submit after this
                userService.resetPassword(this.form.password, this.token)
                    .then(() => {this.success = true;})
                    .catch(() => {this.fail = true;});
            },
        }
    }
</script>

<style scoped>

</style>
